import { createFileRoute } from "@tanstack/react-router";
import SocialMedia from "@/pages/SocialMedia";
import { seoHead } from "@/lib/seo";
import { industriesQuery, projectsLeanQuery, safePrefetch } from "@/lib/publicQueries";

export const Route = createFileRoute("/socialmedia")({
  loader: async ({ context }) => {
    await Promise.all([
      safePrefetch(context.queryClient, projectsLeanQuery({ publicOnly: true })),
      safePrefetch(context.queryClient, industriesQuery()),
    ]);
  },
  head: () =>
    seoHead({
      title: "Social Media Content Mannheim: Reels & Fotos | Clicks DMP",
      description:
        "Wöchentlich neue Reels und Fotos für Ihr Unternehmen in Mannheim und Rhein-Neckar. Drehtag bei Ihnen vor Ort, Schnitt, Titel und Hashtags inklusive.",
      path: "/socialmedia",
    }),
  component: SocialMedia,
});
